export const amountFormatter = new Intl.NumberFormat('us');
